import { Box } from '@trmediaab/zebra';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import {
  FactHeading,
  FactItemsGroup,
  VerticalList,
} from '~/components/Elements';

import { findStartByLegStartNumber } from '../utils';
import Start from './Start';

export default class Bankers extends PureComponent {
  static propTypes = {
    round: PropTypes.object.isRequired,
  };

  render() {
    const { round } = this.props;

    const systems = round.systems;

    if (systems) {
      const system = [...round.systems]
        .sort((a, b) => b.premium - a.premium)
        .find(system => system.type === 'small');

      if (system) {
        return (
          <Box bg="white" px={{ _: 3, md: '3,5' }} py={{ _: 3, md: '3,5' }}>
            <FactItemsGroup>
              <FactHeading>Spikarna</FactHeading>

              <VerticalList>
                {Object.keys(system.bankers)
                  .map(leg => Number.parseInt(leg, 10))
                  .map(leg => {
                    const start = findStartByLegStartNumber(
                      round,
                      leg,
                      Number.parseInt(system.bankers[leg], 10),
                    );

                    return start ? (
                      <li key={`${leg}_${system.bankers[leg]}`}>
                        <Start
                          start={start}
                          betType={round.bet_type}
                          leg={leg}
                        />
                      </li>
                    ) : null;
                  })
                  .filter(Boolean)}
              </VerticalList>
            </FactItemsGroup>
          </Box>
        );
      }
    }

    return null;
  }
}
